import { LanguageCode } from "common/types/languageCode";

const supportedLanguages = [LanguageCode.EN, LanguageCode.ZH, LanguageCode.JA, LanguageCode.ES] as const;
type SupportedLanguage = (typeof supportedLanguages)[number];
const supportedLanguagesSet = new Set<LanguageCode>(supportedLanguages);
const isSupported = (language: LanguageCode): language is SupportedLanguage => supportedLanguagesSet.has(language);
export const supportifyLanguage = (language: LanguageCode): SupportedLanguage =>
  isSupported(language) ? language : LanguageCode.EN;
